<!-- 多选 -->
<template>
  <el-checkbox-group :disabled="!isEditor" v-model="value" @change="mySubmit">
    <el-checkbox v-for="k in source" :label="k.optional_value" :key="k">
      {{ k.optional_label }}
    </el-checkbox>
  </el-checkbox-group>
</template>
<script>
import { isJSON } from '@/utils'
import { defineComponent, computed } from 'vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 's-checkbox',
  inheritAttrs: false,
  props: { ...baseProps, modelValue: [String, Array, Number] },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    const source = computed(() => {
      if (props.item.optionalValue && isJSON(props.item.optionalValue)) {
        return JSON.parse(props.item.optionalValue)
      } else {
        return []
      }
    })
    return {
      source,
      ...controlItemManage(props, context)
    }
  }
})
</script>
